(function (angular) {
  angular.module("alk.routeExceptions", [
    "alk.linkMapping"
  ]);
})(window.angular);

require("../alk-link-mapping/module.js");
require("../alk-link-mapping/alkLinkMapping.service.js");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-route-exceptions/module.js